import { Layer, Box, Text, Button } from 'grommet';
import React from 'react';
import './SuccessModal.css';
import changePassword from '../../../../../../../assets/change-password.gif';
import { useStore } from '../../../../../../../Hooks/useStore';
import { useNavigate } from 'react-router-dom';

const SuccessModal = ({ successMsg }) => {
    const { rootStore } = useStore();
    const navigate = useNavigate();

    const onGoHomeClick = () => {
        rootStore.emsStore.handleErrorTxt("");
        navigate("/medical-emergencies");
        // window.location.replace("http://localhost:3000/medical-emergencies");
    }

    return(
        <> 
            {
                successMsg == "success"
                    ?
                <Layer>
                    <Box className='reset-modal-container'>
                        <img className="change-password-img" src={changePassword} alt="password changes successfully." />
                        <Text className='change-password-txt'>Password changed <br />successfully!</Text>
                        <Button onClick={onGoHomeClick} className='go-home-btn' label="Back to homepage" />
                    </Box>
                </Layer>
                    :
                null
            }
        </>
    )
}

export default SuccessModal;